import React, { useEffect, useState, useImperativeHandle } from 'react';
import { Alert, Button, Form, Radio } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

const FormPublish = ( { form, modifiedCallback = () => {}, disabled = false, saveCallback, 
    hideHelp = false, canPublishCallback, ref } ) => {      
    const [ publishedValue, setPublishedValue ] = useState( 0 ); 
    const [ showHelp, setShowHelp ] = useState( false ); 

    useEffect( () => {
        setPublishedValue( form.getFieldValue( 'published' ) );
    }, [ form ] );

    useImperativeHandle( ref, () => ( {
        reset() {
            form.setFieldsValue( { publishedIsModified: false } ); 
            form.setFieldsValue( { publishedModified: undefined } ); 
            setPublishedValue( form.getFieldValue( 'published' ) );
            modifiedCallback( false ); 
        }
    } ) );
    
    const updateModified = () => { 
        if ( form.getFieldValue( 'published' ) !== form.getFieldValue( 'publishedModified' ) ) {
            form.setFieldsValue( { publishedIsModified: true } ); 
            modifiedCallback( true ); 
        } else {
            form.setFieldsValue( { publishedIsModified: false } ); 
            form.setFieldsValue( { publishedModified: undefined } ); 
            modifiedCallback( false ); 
        }
    };
    
    const handleValueChange = ( e ) => { 
        if ( e.target.value === true && canPublishCallback && canPublishCallback() === false ) {
            return;
        }
    
        setPublishedValue( e.target.value );
        form.setFieldsValue( { publishedModified: e.target.value } ); 
        updateModified();
        if ( saveCallback ) {
            saveCallback( e.target.value );
        }
    };

    const handleToggleHelp = () => {
        setShowHelp( !showHelp );
    };

    return (
        <div className="form-item-published">
                
            <div 
                style={ { display: 'flex' } }
            >
                <Form.Item 
                    label={ <h4 style={ { marginBottom: '0' } }>Publishing</h4> }
                >
                    <Radio.Group 
                        disabled={ disabled }
                        size="medium"
                        buttonStyle="solid" 
                        value={ publishedValue } 
                        onChange={ handleValueChange }
                    >
                        <Radio.Button value={ true }>
                            Publish
                        </Radio.Button>
                        <Radio.Button value={ false }>
                            Unpublish
                        </Radio.Button>
                    </Radio.Group>
                </Form.Item>
                
                { !hideHelp &&
                    <Button
                        size="small" 
                        shape="circle"
                        style={ { marginTop: '33px', marginLeft: '13px' } }
                        onClick={ handleToggleHelp }
                        onClose={ handleToggleHelp }
                    >
                        <QuestionCircleOutlined />
                    </Button>
                }
            </div>

            { showHelp &&
                <Alert 
                    type="warning"
                    message="Publishing"
                    style={ { marginBottom: '18px' } }
                    description={ 
                        <>
                            <ul>
                                <li>Published: course is visible to user audience</li>
                                <li>Unpublished: course is not visible to user audience</li>
                            </ul>
                            <p>Object changes:</p>
                            <ul>
                                <li>If objects are removed from a course and then it is Published, user course progress will be
                                    evaluated for completions by the new criteria. Any users who have completed all current objects will change from an In-Progress status to a Completed status.</li>
                                <li>Adding new objects will impact users who have not yet completed the course; they will need to complete all new objects to reach a Complete status. 
                                    Those who have already completed the course retain their status, though the course revision is indicated for future review.</li>
                            </ul>
                        </>
                    }
                />
            }
        </div>
    );
};

export default FormPublish;
